import React from 'react';

const Field = ({
  activeField, activateField, field, fieldId, count,
}) => (
  <span className={activeField === fieldId ? 'radio active' : 'radio'} onClick={event => activateField(event, fieldId)}>
    <label>
      <span dangerouslySetInnerHTML={{ __html: field }} />
      ({count})
    </label>
  </span>
);

export default Field;
